import MainLayout from 'src/components/layout/MainLayout';
import { getLocalUserId, PERMISSION } from 'src/features/auth';
import { useListUserMemberships } from 'src/features/profile/api/useListUserMemberships';
import Home from 'src/features/routes/home/Home';
import HomeRedirect from 'src/features/routes/home/HomeRedirect';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { useParking } from 'src/providers/ParkingProvider';

const HomeRoutes = () => {
    const accessHomeStats = useHasPermissions([PERMISSION.ACCESS_HOME_STATS]);

    const userId = getLocalUserId();
    const { parkingId } = useParking();

    const { data: userMemberships } = useListUserMemberships({ userId, parking: parkingId });
    const isClient = Boolean(userMemberships && userMemberships[0]?.is_client);

    return <MainLayout>{accessHomeStats || isClient ? <Home isClient={isClient} /> : <HomeRedirect />}</MainLayout>;
};

export default HomeRoutes;
